export default __webpack_public_path__ + "static/hyperlane-a824c0dd2b92cfd46afd548ee20dcbcd.png";